"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UNSET = exports.SET = void 0;
var SET = 'data/value/SET';
exports.SET = SET;
var UNSET = 'data/value/UNSET';
exports.UNSET = UNSET;